/**
 * Default configuration values
 */
export const DEFAULT_CONFIG = {
    size: 8,
    seed: '',
    palette: [
        [255, 0, 0], // Red
        [0, 255, 0], // Green
        [0, 0, 255], // Blue
        [255, 255, 0], // Yellow
        [255, 0, 255], // Magenta
        [0, 255, 255], // Cyan
        [255, 128, 0], // Orange
        [128, 0, 255], // Purple
        [0, 0, 0], // Black
        [255, 255, 255], // White
    ],
    sharpness: 1.0,
};
//# sourceMappingURL=types.js.map